module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}


//////////////////
// WEBPACK FOOTER
// /home/justin/dev/todomvc-liveresource-website/~/util/support/isBufferBrowser.js
// module id = 703
// module chunks = 0